




import Vue from 'vue';
import UrlService from '@/services/UrlService';
import { TDictionary, TUrlParams } from '@/types';

export default Vue.extend({
  name: 'ParseUrlParams',

  watch: {
    '$route.query': {
      handler(query: TDictionary<string>) {
        this.parse(UrlService.parseParamsFromUrl(query));
      },
      immediate: true,
    },
  },

  methods: {
    parse(urlParams: TUrlParams) {
      this.$emit('parse', urlParams);
    },
  },
});
